import React, { useState, useEffect } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./toast.css";

const CustomToast = ({ message, type, toastId, autoCloseTime }) => {
  const [progress, setProgress] = useState(100);

  useEffect(() => {
    const interval = 100;
    const decrement = (100 / autoCloseTime) * interval;

    const timer = setInterval(() => {
      setProgress((prev) => {
        const newProgress = prev - decrement;
        if (newProgress <= 0) {
          clearInterval(timer);
          return 0;
        }
        return newProgress;
      });
    }, interval);

    return () => clearInterval(timer);
  }, [autoCloseTime]);

  const handleClose = () => {
    toast.dismiss(toastId);
  };

  return (
    <div
      className={`custom-toast-container toast-${type}`}
    >
      <div className="toast-progress" style={{ width: `${progress}%` }}></div>
      <div className="toast-content">
        {/* <div className="toast-img-container">
          <img src="/images/toast-logo.svg" height="100%" width={64} alt="toast" />
        </div> */}
        <div className="toast-text-container">
          <p>{message}</p>
          <img
            src="/img/closeicon.svg"
            alt="close"
            width={20}
            height={20}
            style={{ cursor: "pointer" }}
            onClick={handleClose}
          />
        </div>
      </div>
    </div>
  );
};

export default CustomToast;
